/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-14 15:33:17                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-25 17:30:55                               *
 *****************************************************************************/

/* SUMMARY
 * Imports
 * Components
 * UnavaibleTechDashCard - display unavaible technicians on dashboard
 */

/* Imports */
import {
  CalendarIcon,
  EnvelopeIcon,
  XCircleIcon,
} from "@heroicons/react/24/solid";
import { Typography } from "@material-tailwind/react";
/***/

/* Components */
import DateDisplay from "../date/DateDisplay";
import Avatar from "../../avatar/Avatar";
/***/

/* Styles */
import "./UnavaibleTechDashCard.scss";
import { useNavigate } from "react-router-dom";
import { t } from "../../../i18n";
/***/

/**
 * UnavaibleTechDashCard - display unavaible technicians on dashboard
 * @param data - technician data to display
 */
export default function UnavaibleTechDashCard({
  data,
}: {
  data: EasyTech.Time;
}) {
  const navigate = useNavigate();

  return (
    <>
      {data.technician && (
        <div className="technician-card" onClick={() => navigate("/planning")}>
          <div className="flex justify-between">
            <div className="flex items-center gap-4">
              <Avatar
                name={data.technician.firstName.toUpperCase()}
                size="md"
              />

              <div className="flex flex-col gap-2">
                <Typography className="text-blue-700 hover:underline">
                  {data.technician.firstName}{" "}
                  {data.technician.lastName.toUpperCase()}
                </Typography>

                <div className="flex gap-[6px]">
                  <EnvelopeIcon className="w-5" />
                  <span>{data.technician.email}</span>
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-2">
              <div className="flex gap-1">
                <div className="icon-text">
                  <div className="flex gap-1">
                    <CalendarIcon className="w-5" />
                    {t("common:from")}
                    <DateDisplay date={new Date(data.date_from)} />
                    {t("common:to")}
                    <DateDisplay date={new Date(data.date_to)} />
                  </div>
                </div>
              </div>

              <div className="flex gap-[6px] items-center">
                <XCircleIcon color="red" className="w-5" />
                {data.type.label}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
/***/
